import React from 'react';
import './AppInfo.css';
import appIcon from './appicon.png';
import productImage3 from './product3.png';
import productImage4 from './product4.png';
import productImage5 from './product5.png';

const AppInfo: React.FC = () => {
  return (
    <section className="app-info">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-4 text-center">
            <img src={appIcon} alt="App Icon" className="rounded img-fluid app-icon" />
          </div>
          <div className="col-md-8 my-3">
            <h2>About Flashcard World Program</h2>
            <p>Flashcard World Program is an educational app designed to help children explore the world through vivid images and sounds. With diverse topics ranging from animals to vehicles, it provides an engaging learning experience that stimulates curiosity and language development.</p>
          </div>
          <div className="col-md-12 mt-5">
            <img src={productImage3} alt="Product 3" className="img-fluid rounded shadow-lg mb-5" />
            <img src={productImage4} alt="Product 4" className="img-fluid rounded shadow-lg mb-5" />
            <img src={productImage5} alt="Product 5" className="img-fluid rounded shadow-lg" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppInfo;
